import {defaultPropiedades, propiedadesDlCl} from './state';

/**
 * Establecer el id del producto
 * @param id_producto Contiene el id del producto
 */
export function establecerIdProductoEnPropiedades(state, id_producto) {
    state.propiedades.id_producto = id_producto;
}

/**
 * Establecer las propiedades de un producto
 * @param propiedades Contiene las propiedades
 */
export function establecerPropiedades(state, propiedades) {
    state.propiedades = propiedades;

    if (!!state.propiedades.propiedades_dl_cl.length) {
        state.propiedades.propiedades_dl_cl.map(dl_cl => {
            dl_cl.error = false;
        });
    } else {
        state.propiedades.propiedades_dl_cl.push(propiedadesDlCl());
    }
}

export function establecerUnidadesDensidad(state, unidadesDensidad) {
    state.unidadesDensidad = unidadesDensidad;
}

/**
 * Limpiar las propiedades de un producto
 */
export function setDefaultPropiedades(state) {
    Object.assign(state.propiedades, defaultPropiedades());
}

/**
 * Establecer el valor para la variable de estado lista_temporal
 */
export function establecerListaTemporal(state, lista_temporal) {
    state.lista_temporal = lista_temporal;
}

/**
 * Establecer el valor para la variable de estado presentaciones
 */
export function establecerPresentaciones(state, presentaciones) {
    state.presentaciones = presentaciones;
}

/**
 * Establecer el valor para la variable de estado unidades_de_temperatura
 */
export function establecerUnidadesDeTemperatura(state, unidades_de_temperatura) {
    state.unidades_de_temperatura = unidades_de_temperatura;
}

/**
 * Establecer el valor para la variable de estado unidades_de_presion
 */
export function establecerUnidadesDePresion(state, unidades_de_presion) {
    state.unidades_de_presion = unidades_de_presion;
}

/**
 * Establecer el valor para la variable de estado unidades_de_viscosidad
 */
export function establecerUnidadesDeViscosidad(state, unidades_de_viscosidad) {
    state.unidades_de_viscosidad = unidades_de_viscosidad;
}

/**
 * Establecer el valor para la variable de estado opciones_dl50
 */
export function establecerOpcionesDl50(state, opciones_dl50) {
    state.opciones_dl50 = opciones_dl50;
}

/**
 * Establecer el valor para la variable de estado opciones_cl50
 */
export function establecerOpcionesCl50(state, opciones_cl50) {
    state.opciones_cl50 = opciones_cl50;
}

/**
 * Establecer el valor para la variable de estado capacidades
 */
export function establecerCapacidades(state, capacidades) {
    state.capacidades = capacidades;
}

/**
 * Establecer el valor para la variable de estado opciones_superficies_expuestas
 */
export function establecerOpcionesSuperficiesExpuestas(state, opciones_superficies_expuestas) {
    state.opciones_superficies_expuestas = opciones_superficies_expuestas;
}

/**
 * Establecer el valor para la variable de estado clases_de_procedimiento
 */
export function establecerClasesDeProcedimiento(state, clases_de_procedimiento) {
    state.clases_de_procedimiento = clases_de_procedimiento;
}

/**
 * Establecer el valor para la variable de estado clases_de_pulverulencia
 */
export function establecerClasesDePulverulencia(state, clases_de_pulverulencia) {
    state.clases_de_pulverulencia = clases_de_pulverulencia;
}

/**
 * Establecer el valor para la variable de estado unidades_de_medida_tlv
 */
export function establecerUnidadesDeMedidaTlv(state, unidades_de_medida_tlv) {
    state.unidades_de_medida_tlv = unidades_de_medida_tlv;
}

/**
 * Establecer el valor para la variable de estado animales
 */
export function establecerAnimales(state, animales) {
    state.animales = animales;
}

/**
 * Establecer error al dl_cl
 */
export function establecerErrorDlCl(state, {indice, error}) {
    state.propiedades.propiedades_dl_cl[indice].error = error;
}


/**
 * Agregar objeto DlCl
 */
export function agregarDlCl(state) {
    state.propiedades.propiedades_dl_cl.push(propiedadesDlCl());
}

/**
 * Eliminar objeto DlCl
 */
export function eliminarDlCl(state, indice) {
    state.propiedades.propiedades_dl_cl.splice(indice, 1);
}

